import React, { createContext, useContext, useState, useEffect } from 'react';

const LandingDataContext = createContext(null);

const DEFAULT_CONTENT = {
  hero: {
    overline: "DA'VM Collection",
    title: "Kemewahan Sempurna",
    italicTitle: "untuk Kulit Anda.",
    subtitle: "Rangkaian perawatan eksklusif DA'VM — mencerahkan, meremajakan, dan merawat kulit Anda dengan bahan pilihan premium yang terinspirasi ritual kecantikan mewah.",
    bgImage: "https://images.unsplash.com/photo-1618434958571-459c9c972ae8?q=85&w=2000&auto=format&fit=crop",
    stats: [
      { num: "7+", label: "Produk Eksklusif" },
      { num: "100%", label: "Bahan Terpilih" },
      { num: "BPOM", label: "Terdaftar Resmi" },
      { num: "1000+", label: "Wanita Percaya" }
    ]
  },
  productsSection: {
    overline: "— Koleksi Eksklusif",
    title: "Ritual perawatan mewah,",
    italicTitle: "dirancang untuk Anda.",
    description: "Setiap produk DA'VM diformulasikan dengan cermat untuk menghadirkan pengalaman perawatan kulit yang elegan, aman, dan efektif — mulai dari pagi hingga malam hari."
  },
  products: [
    {
      id: "day-cream",
      name: "Day Cream Brightening",
      category: "Skincare",
      tagline: "Cahaya di setiap sentuhan pagi.",
      image: "/products/day-cream.png",
      description: "Krim siang ringan yang menutrisi dan melindungi kulit dari paparan lingkungan, sekaligus mencerahkan serta meratakan warna kulit sehingga wajah tampak lebih segar sepanjang hari.",
      benefits: [
        "Melembapkan kulit sepanjang hari",
        "Melindungi dari paparan lingkungan",
        "Mencerahkan & meratakan warna kulit",
        "Menjaga elastisitas kulit"
      ]
    },
    {
      id: "night-cream",
      name: "Night Cream Whitening",
      category: "Skincare",
      tagline: "Regenerasi mewah dalam setiap tidur.",
      image: "/products/night-cream.jpg",
      description: "Krim malam intensif yang mendukung regenerasi kulit saat tidur, menutrisi secara maksimal, membantu menyamarkan bekas jerawat dan menjaga kelembapan semalaman.",
      benefits: [
        "Regenerasi kulit saat tidur",
        "Menutrisi kulit secara maksimal",
        "Menyamarkan bekas jerawat",
        "Menjaga kelembapan semalaman"
      ]
    },
    {
      id: "facial-wash",
      name: "Facial Wash Brightening",
      category: "Skincare",
      tagline: "Kelembutan yang membersihkan sempurna.",
      image: "/products/facial-wash.jpg",
      description: "Pembersih wajah yang membersihkan menyeluruh tanpa membuat kulit kering — menjaga kelembapan alami, mengontrol minyak, dan menyegarkan wajah dalam setiap basuhan.",
      benefits: [
        "Membersihkan secara menyeluruh",
        "Menjaga kelembapan alami",
        "Membantu mengontrol minyak",
        "Mencegah timbulnya jerawat"
      ]
    },
    {
      id: "serum-whitening",
      name: "Serum Whitening",
      category: "Skincare",
      tagline: "Konsentrat cahaya untuk kulit istimewa.",
      image: "/products/serum-whitening.png",
      description: "Serum konsentrat tinggi yang menutrisi kulit lebih intensif, membantu mencerahkan, menyamarkan noda dan bekas jerawat, serta mendukung regenerasi kulit yang lebih halus.",
      benefits: [
        "Nutrisi intensif untuk kulit",
        "Mencerahkan wajah secara merata",
        "Menyamarkan noda & bekas jerawat",
        "Menghaluskan tekstur kulit"
      ]
    },
    {
      id: "face-toner",
      name: "Face Toner Brightening",
      category: "Skincare",
      tagline: "Keseimbangan alami sebelum ritual.",
      image: "/products/face-toner.jpg",
      description: "Toner ringan yang menyeimbangkan pH kulit, mengangkat sisa kotoran, mengecilkan tampilan pori, serta menenangkan kulit — mempersiapkan wajah untuk ritual selanjutnya.",
      benefits: [
        "Menyeimbangkan pH kulit",
        "Membersihkan sisa kotoran",
        "Mengecilkan tampilan pori",
        "Menenangkan kulit sensitif"
      ]
    },
    {
      id: "sunscreen",
      name: "Sunscreen Serum 3in1",
      category: "Skincare",
      tagline: "Perisai tak terlihat, kilau tak tertandingi.",
      image: "/products/sunscreen.jpg",
      description: "Sunscreen bertekstur ringan yang melindungi dari sinar UV, mencerahkan, menghidrasi, dan mencegah penuaan dini — perlindungan menyeluruh dengan hasil glowing alami.",
      benefits: [
        "Melindungi dari sinar UV",
        "Mencerahkan & meratakan warna kulit",
        "Mencegah penuaan dini",
        "Menjaga skin barrier tetap sehat"
      ]
    },
    {
      id: "body-lotion",
      name: "Body Lotion Glow",
      category: "Bodycare",
      tagline: "Kilau lembut hingga ujung tubuh.",
      image: "/products/body-lotion.jpg",
      description: "Lotion tubuh mewah yang melembapkan dan mencerahkan kulit tubuh dengan aroma yang tahan lama — meninggalkan kilau lembut yang menyatu dengan kulit.",
      benefits: [
        "Melembapkan kulit tubuh",
        "Mencerahkan kulit secara bertahap",
        "Aroma mewah tahan lama",
        "Tekstur ringan mudah menyerap"
      ]
    }
  ],
  benefitsSection: {
    overline: "— Mengapa DA'VM",
    title: "Filosofi kecantikan",
    italicTitle: "yang mewah & jujur.",
    description: "Kami percaya kecantikan sejati lahir dari kepercayaan diri. Setiap formula DA'VM dirancang untuk merawat kulit Anda — dengan integritas, kualitas, dan sentuhan mewah."
  },
  benefits: [
    {
      title: "Bahan Premium",
      description: "Diformulasikan dengan bahan aktif terpilih yang mewah, aman, dan efektif untuk hasil terbaik.",
      icon: "Sparkles"
    },
    {
      title: "Teruji & Terdaftar",
      description: "Setiap produk telah melalui uji kualitas serta terdaftar resmi untuk memastikan keamanannya.",
      icon: "ShieldCheck"
    },
    {
      title: "Lembut untuk Kulit",
      description: "Formulasi lembut yang cocok bahkan untuk kulit sensitif — tanpa bahan berbahaya.",
      icon: "Leaf"
    },
    {
      title: "Hasil yang Nyata",
      description: "Ribuan wanita telah merasakan kulit lebih cerah, halus, dan sehat bersama DA'VM.",
      icon: "Star"
    }
  ],
  about: {
    overline: "— Cerita Kami",
    title: "Lahir dari cinta terhadap",
    italicTitle: "kecantikan sejati.",
    image: "/brand/about-hero.jpg",
    quote: "Merawat kulit adalah bentuk cinta paling lembut kepada diri sendiri.",
    paragraphs: [
      "DA'VM hadir untuk memberikan pengalaman merawat diri yang mewah dan menenangkan. Kami menggabungkan sains modern dengan kekayaan alam Indonesia untuk menciptakan formula skincare yang lembut, efektif, dan aman untuk pemakaian harian.",
      "Setiap tetes serum, setiap sentuhan krim adalah bagian dari ritual yang mengingatkan Anda: kecantikan bukan tentang kesempurnaan, melainkan tentang merasa nyaman dan percaya diri pada diri sendiri."
    ]
  },
  testimonialsSection: {
    overline: "— Bukti Nyata",
    title: "Cerita dari mereka yang",
    italicTitle: "telah percaya."
  },
  testimonials: [
    {
      quote: "Setelah rutin memakai serum dan day cream DA'VM, kulit saya terasa jauh lebih cerah dan bercahaya. Teksturnya ringan dan wanginya mewah.",
      name: "Anindya P.",
      role: "Pelanggan Setia — Jakarta"
    },
    {
      quote: "Saya jatuh cinta pada night cream-nya. Bangun pagi kulit terasa kenyal, lembap, dan bekas jerawat perlahan memudar.",
      name: "Rania S.",
      role: "Ibu Muda — Bandung"
    },
    {
      quote: "Sunscreen 3in1-nya luar biasa — ringan, tidak lengket, dan wajah tetap glowing seharian. Kini jadi wajib di tas saya.",
      name: "Melodi K.",
      role: "Beauty Enthusiast — Surabaya"
    },
    {
      quote: "Pertama kali coba brand lokal yang benar-benar terasa mewah. Kemasan cantik dan hasilnya juga memuaskan.",
      name: "Karina W.",
      role: "Reseller — Bali"
    }
  ]
};

export const LandingDataProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  // Check login state
  useEffect(() => {
    const logged = localStorage.getItem('davm_admin_logged') === 'true';
    setIsAdmin(logged);
  }, []);

  // Fetch content on mount
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/content');
      if (response.ok) {
        const data = await response.json();
        // Merge with defaults to ensure all keys exist
        setContent(prev => ({
          ...DEFAULT_CONTENT,
          ...data,
          hero: { ...DEFAULT_CONTENT.hero, ...data.hero },
          productsSection: { ...DEFAULT_CONTENT.productsSection, ...data.productsSection },
          about: { ...DEFAULT_CONTENT.about, ...data.about },
          benefitsSection: { ...DEFAULT_CONTENT.benefitsSection, ...data.benefitsSection },
          testimonialsSection: { ...DEFAULT_CONTENT.testimonialsSection, ...data.testimonialsSection }
        }));
      } else {
        // Use localstorage backup
        const backup = localStorage.getItem('davm_landing_content');
        if (backup) {
          setContent(JSON.parse(backup));
        }
      }
    } catch (err) {
      console.warn('API content fetch failed, using local backup/defaults', err);
      const backup = localStorage.getItem('davm_landing_content');
      if (backup) {
        setContent(JSON.parse(backup));
      }
    } finally {
      setLoading(false);
    }
  };

  const login = (username, password) => {
    if (username === 'dyshagroup@gmail.com' && password === 'O9o21o00') {
      localStorage.setItem('davm_admin_logged', 'true');
      setIsAdmin(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('davm_admin_logged');
    setIsAdmin(false);
  };

  const saveContent = async (newContent) => {
    setContent(newContent);
    localStorage.setItem('davm_landing_content', JSON.stringify(newContent));

    try {
      const response = await fetch('/api/content', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newContent)
      });
      if (response.ok) {
        return { success: true };
      } else {
        throw new Error('API return non-ok status');
      }
    } catch (err) {
      console.error('Failed to save to backend, saved to localStorage only:', err);
      return { success: false, message: 'Saved to browser cache only. Server unreachable.' };
    }
  };

  const uploadImageFile = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        try {
          const base64Data = reader.result.split(',')[1];
          const response = await fetch('/api/upload', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              fileName: file.name,
              fileType: file.type,
              fileData: base64Data
            })
          });

          if (response.ok) {
            const data = await response.json();
            if (data.success) {
              resolve(data.url);
            } else {
              reject(data.error || 'Upload failed');
            }
          } else {
            reject('Server upload failed');
          }
        } catch (err) {
          reject(err.message || 'Error during upload request');
        }
      };
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <LandingDataContext.Provider
      value={{
        content,
        loading,
        isAdmin,
        login,
        logout,
        saveContent,
        uploadImageFile,
        refreshContent: fetchContent,
        setTempContent: setContent
      }}
    >
      {children}
    </LandingDataContext.Provider>
  );
};

export const useLandingData = () => {
  const context = useContext(LandingDataContext);
  if (!context) {
    throw new Error('useLandingData must be used within a LandingDataProvider');
  }
  return context;
};
